import config from '../../configuration';

export const apiRoot = config.publicApiRoot;

const endpoints = {
  dealers: `${apiRoot}/dealers`,
  dealer: `${apiRoot}/dealer`,
  booking: `${apiRoot}/booking`,
  car: `${apiRoot}/car`,
  request: `${apiRoot}/request`,
  payment: `${apiRoot}/payment`,
  address: `${apiRoot}/address`,

  services: `${apiRoot}/Services`,
  extras: `${apiRoot}/Extras`,

  service_request: `${apiRoot}/service_request`,
  kvk: `${apiRoot}/kvk`,
};

export default endpoints;
